var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[_c('CircledAvatar',{class:_vm.imageClass,attrs:{"size":_vm.imageSize,"src":_vm.image},on:{"click":_vm.onClickImage}}),_c('div',{class:_vm.TextClass,on:{"click":_vm.onClickText}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }